import styled from 'styled-components';
import DefaultInput from 'components/Form/Input';
import { BaseFormSelect } from 'components/Form/FormSelect';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.white};
  padding: 2rem;
  border-radius: 1.5rem;
`;

// TODO: TFR-44 move to container group
export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1.5rem;
  margin-top: 2rem;
`;

// TODO: TFR-45:Input make unique name or do not export
export const Input = styled(DefaultInput)`
  input {
    font-weight: 500;
    font-size: 1.1875rem;
  }
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Select = styled(BaseFormSelect)``;
